<template>
    <div class="header-fixed" id="header-fixed" :class="{slicky: slicky}"v-if="setup != null">
        <div class="container">
            <div class="main-logo">
                <a href="#">
                    <img :src="setup.logo" alt="">
                    <img :src="setup.logo_white" class="logo-white" alt="">
                </a>
            </div>
            <div class="header-fixed-navigation">
                <navMain class="header-fixed-nav navigation-scroll-spy" id="navigation"></navMain>
            </div>
            <div class="lang">
                <div class="lang--picker">
                    <a href="#" class="lang-link-select">
                        <svg-icon icon-class="down-arrow" className="icon-down-arrow"/>
                        <span class="body-lang-ru">Русский</span>
                        <span class="body-lang-kz">Казахский</span>
                    </a>
                </div>
                <div class="select--languages">
                    <ul>
                        <li class="select-link select-link-ru">
                            <a href="#" @click.prevent="setLocale('')">Русский</a>
                        </li>
                        <li class="select-link select-link-kz">
                            <a href="#" @click.prevent="setLocale('kz/')">Казахский</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="change-date-time">
                <ul>
                    <li><a href="#" @click.prevent="changeDayTime('day')">{{setup.btn_change_time.day}}</a></li>
                    <li><a href="#" @click.prevent="changeDayTime('night')">{{setup.btn_change_time.night}}</a></li>
                </ul>
            </div>
            <div class="phone-modal-btn">
                <a href="#" class="btn-phone-modal" @click.prevent="openFormModal">
                    <svg-icon icon-class="phone" className="icon-phone"/>
                    <p>{{setup.header_phone}}</p>
                </a>
            </div>
            <div class="bazis-logo">
                <a :href="setup.logo_bazis.link" target="_blank">
                    <img :src="setup.logo_bazis.img" alt="">
                    <img :src="setup.logo_bazis_white" class="logo-white" alt="">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import navMain from '@/components/nav-main/nav-main.vue'
    
    export default {
        name: 'HeaderFixed',
        props: ['respond'],
        components: {
            navMain
        },
        data () {
            return {
                slicky: false
            }
        },
        methods: { 
            slickyHeader() {
                if (window.scrollY >= 1500) {
                    this.slicky = true;
                } else {
                    this.slicky = false;
                }
            },
            scrollSpyNavigation () {
                $('html,body').scrollspy({ 
                    target: '.navigation-scroll-spy',
                    offset: 75
                });
            },
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            changeDayTime(time) {
                localStorage.setItem('dayTime', time);
                document.querySelector('body').dataset.themeTime = localStorage.getItem('dayTime');
            },
            openFormModal() {
                this.$store.commit('Open_Form_Modal', true);
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            }
        },
        created () {
            window.addEventListener('scroll', this.slickyHeader);
        },
        destroyed() {
            window.removeEventListener('scroll', this.slickyHeader);
        },
        mounted () {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue.main_page_navigation.length >= 5) {
                        this.slickyHeader();
                        this.scrollSpyNavigation();
                    }
                }
            )
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/header-fixed/header-fixed.scss';
</style>